export const coresGraficoContasPagar = {
  vermelho: '#b53838',
  verde: '#2dc44d',
  azul: '#3286a8',
  laranja: '#e65c17',
};
